
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dental",
      function () {
        return require("private-next-pages/dental.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dental"])
      });
    }
  